import styled from 'styled-components'
import { Button } from 'grommet/components/Button'
import colors from '@constants/colors'
import Modal from 'styled-react-modal'
import hexToRgba from 'hex-to-rgba'
import i18n from '@localization/i18n'

export const Flex1 = styled.div`
    flex: 1;
    padding: 0 20px;
`
export const Flex2 = styled.div`
    flex: 2;
    padding: 0 40px;
`

export const SongsWrapper = styled.div`
    background-color: red;
    display: inline-flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-around;
    padding: 0.5rem 0rem 0px;
    margin: -1rem 0 0rem;
    align-items: center;
    border-top: 1px solid #ebebeb;
    border-bottom: 1px solid #ebebeb;
    background-color: #ebebeb;
    position: relative;
    @media (max-width: 768px) {
        flex-direction: column;
        padding: 0;
    }
`

export const ButtonsGroupContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 0px;

    @media (max-width: 768px) {
        font-size: 14px;
    }
`

export const MainButton = styled(Button)`
    width: auto;
    border: none;
    display: flex;
    color: #ffffff;
    font-size: 16px;
    padding: 4px 12px;
    text-align: center;
    border-radius: 1rem;
    align-items: center;
    flex-direction: column;
    background-color: ${colors.BUTTON_DARK};
    & span {
        font-size: 14px;
    }
`

export const SelectBtn = styled.div`
    width: 100%;
    font-size: 13px;
    font-weight: 300;
    color: ${colors.APP_BLACK};
    min-width: 156px;

    & input {
        padding: 10px;
        border: 1px solid grey;
    }
`

export const SearchSelectBtn = styled.div`
    width: 540px;
    font-size: 13px;
    font-weight: 300;
    margin: 0px 4px;
    color: #000000;
    min-width: 165px;

    @media (max-width: 768px) {
        width: 330px;
    }
`

export const Wrapper = styled.div`
    padding-top: 24px;
    background-color: #ebebeb;
    /* padding: 0rem 0 2rem 0rem; */
`

export const SelectWrapper = styled.div`
    display: inline-flex;
    margin-top: 3rem;
    width: 100%;
    flex-direction: column;
    @media (max-width: 768px) {
        margin-top: 6rem;
    }
    & h2 {
        margin: 0;
        text-align: right;
        color: rgb(152, 135, 152);
        font-weight: 400;
    }
`

export const Row = styled.div`
    display: inline-flex;
    flex-direction: row;
    margin: 0;
    justify-content: flex-start;
    width: 100%;
    & label {
        font-size: 12px;
        color: rgb(152, 135, 152);
    }
    @media (max-width: 768px) {
        flex-direction: column;
    }
`
export const selectCustomStyles = {
    control: (base, state) => ({
        ...base,
        background: '#fff',
        fontSize: '13px',
        fontColor: 'grey',
        direction: 'rtl',
        lineHeight: 1,
        borderColor: state.isFocused ? 'grey' : 'grey',
        boxShadow: state.isFocused ? null : null,
        '&:hover': {
            borderColor: 'blue',
        },
    }),
    menu: (base) => ({
        ...base,
        top: 32,
        position: 'reative',
    }),
}

export const PageHeader = styled.h2`
    text-align: center;
    margin: 20px 0px;
`

export const PageSubTitle = styled.h5`
    text-align: center;
    margin: 4px 0px 12px;
    padding: 0px 20px;
`

export const MainPageWrapper = styled.div`
    display: flex;
    padding-top: 24px;
    align-items: center;
    flex-direction: column;
    /* justify-content: center; */
    /* min-height: calc(100vh - ${(p) => p.headerHeight}px); */
    min-height: calc(100vh - 130px);
    background-color: ${(P) =>
        P.backgroundColor ? P.backgroundColor : colors.APP_GRAY_LIGHT};

    @media (max-width: 768px) {
        min-height: calc(100vh - 54px);
    }
`

export const ContentCenteredBox = styled.div`
    display: flex;
    text-align: ${i18n.locale === 'he' ? 'right' : 'left'};
    flex-direction: column;
    max-width: 880px;
    padding: 0px 20px;
`

export const TextBtn = styled.button`
    color: blue;
    border: none;
    padding: 0px 4px;
    background-color: transparent;
`

export const SubmitWrapper = styled.div`
    padding-bottom: 24px;

    @media (max-width: 768px) {
        width: 100%;
        padding: 0px 20px;
    }
`

export const SubmitButtonsRow = styled.div`
    display: flex;
    margin-bottom: 16px;
    /* justify-content: center; */
    @media (max-width: 768px) {
        display: initial;
        width: 100%;
        padding: 0 12px;
    }
`

export const SubmitBtnContainer = styled.div`
    flex: 1;
    display: flex;
    margin: 20px 0;
    justify-content: center;
`
export const SubmitBtn = styled.button`
    color: ${(p) =>
        p.disabled
            ? p.color
                ? hexToRgba(p.color, 0.75)
                : colors.APP_WHITE
            : p.color
            ? p.color
            : colors.APP_WHITE};
    min-width: 148px;
    padding: 8px 16px;
    font-size: 16px;
    margin: 0 8px;
    text-align: center;
    white-space: nowrap;
    border-radius: 24px;
    border: solid 1px
        ${(p) => (p.disabled ? colors.APP_GRAY_DARK : colors.BUTTON_DARK)};
    background-color: ${(p) =>
        p.disabled
            ? p.backgroundColor
                ? hexToRgba(p.backgroundColor, 0.4)
                : hexToRgba(colors.BUTTON_DARK, 0.4)
            : p.backgroundColor
            ? p.backgroundColor
            : colors.BUTTON_DARK};
    &:hover {
        background-color: ${(p) =>
            p.disabled
                ? p.backgroundColor
                    ? hexToRgba(p.backgroundColor, 0.4)
                    : hexToRgba(colors.BUTTON_DARK, 0.4)
                : p.backgroundColor
                ? hexToRgba(p.backgroundColor, 0.8)
                : hexToRgba(colors.BUTTON_DARK, 0.8)};
    }
    @media (max-width: 768px) {
        width: 100%;
    }
`

// modals

export const StyledModal = Modal.styled`
  max-width: 400px;
  min-height: 220px;
  display: flex;
  flex-direction: column;
  background-color: ${colors.APP_WHITE};
  padding: 20px 28px 24px;
  border-radius: 8px;
  justify-content: space-between;
`
export const ModalTopPart = styled.div``

export const ModalTitle = styled.h4`
    padding: 8px 0px 20px;
    text-align: center;
    color: ${(p) => (p.error ? 'red' : colors.APP_TEXT)};
`
export const ModalMainText = styled.div`
    text-align: center;
    /* padding: 0 20px; */
`

export const ModalButtonsContainer = styled.div`
    display: flex;
    width: 200px;
    margin: 20px auto 0px;
    justify-content: space-between;
`

// form
export const FormWrapper = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
`
export const FormSection = styled.div`
    margin: 20px 0px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
`
export const FormSectionTitle = styled(PageSubTitle)`
    margin: 0px;
    align-self: flex-start;
`

export const FormRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: ${(p) =>
        p.justifyContent ? p.justifyContent : 'initial'};
    width: 100%;
    max-width: 768px;
    align-items: ${(p) => (p.alignItems ? p.alignItems : 'flex-start')};
    @media (max-width: 768px) {
        flex-direction: column;
    }
`

const addPxIfNum = (width) => {
    if (typeof width === 'number') {
        return width + 'px'
    }

    return width
}

export const FormInputContainer = styled.div`
    flex: 1;
    display: flex;
    padding: 10px 20px;
    flex-direction: column;
    text-align: ${(p) => (p.lang === 'he' ? 'right' : 'left')};
    width: ${(p) => (p.width ? addPxIfNum(p.width) : '100%')};
    min-width: ${(p) => (p.width ? addPxIfNum(p.width) : 'initial')};
    max-width: ${(p) => (p.width ? addPxIfNum(p.width) : 'initial')};
    @media (max-width: 480px) {
        width: 100%;
        min-width: initial;
        max-width: initial;
    }
`
export const FormInputLabel = styled.label`
    width: 100%;
    margin: 0px 0px 4px;
    text-align: ${(p) => (p.lang === 'he' ? 'right' : 'left')};
    color: #6b576b;
`

export const ErrorText = styled.span`
    color: red;
    text-align: center;
    width: 100%;
    min-height: 24px;
`

export const WrapperDiv = styled.div`
    width: 100%;
    text-align: center;
`
export const GrayWrapper = styled.div`
    flex: 1;
    width: 100%;
    padding-top: 20px;
    background-color: ${colors.APP_GRAY_LIGHT};
`

export const RequiredSign = styled.span`
    color: red;
`

export const TableButton = styled.button`
    font-size: 12px;
    padding: 0px 8px;
    line-height: 20px;
    border-radius: 4px;
    white-space: nowrap;
    ${(p) => p.alignSelf && 'align-self:' + p.alignSelf + ';'}
    color: ${colors.APP_WHITE};
    background-color: ${colors.BUTTON_DARK};
`
